export function isX(channelType) {
  return channelType === 'X' || channelType === 'XBand';
}
export function isY(channelType) {
  return channelType === 'Y' || channelType === 'YBand';
}
export function isXOrY(channelType) {
  return isX(channelType) || isY(channelType);
}